import { JetView } from 'webix-jet';

/**
 * Class representing the details view for withdrawal requests.
 * @extends JetView
 */
export default class detailsWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Main information section configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    cols: [
                        {
                            rows: [
                                {
                                    view: 'text',
                                    name: 'Id',
                                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // ID field with icon
                                    labelPosition: 'top',
                                    placeholder: _('Id'),
                                    invalidMessage: _('A ID is required'), // Validation message
                                    disabled: true, // Field is disabled
                                },
                                {
                                    view: 'text',
                                    name: 'Type',
                                    label: _('Tipo'), // Type field
                                    labelPosition: 'top',
                                    placeholder: _('Tipo'),
                                    disabled: true, // Field is disabled
                                },
                                {
                                    view: 'text',
                                    name: 'Date',
                                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date field with icon
                                    labelPosition: 'top',
                                    placeholder: _('Fecha'),
                                    disabled: true, // Field is disabled
                                },
                                {
                                    view: 'text',
                                    name: 'Amount',
                                    label: _('Monto'), // Amount field
                                    labelPosition: 'top',
                                    placeholder: _('Monto'),
                                    disabled: true, // Field is disabled
                                    id: 'Monto', // ID for later reference
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Second main information section configuration
        const second_main_info = {
            margin: 10,
            rows: [
                {
                    view: 'textarea',
                    name: 'PaymentSystemName',
                    label: _('Nombre sistema de pago'), // Payment system name field
                    labelPosition: 'top',
                    placeholder: _('Nombre sistema de pago'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'textarea',
                    name: 'Description',
                    label: _('Descripción'), // Description field
                    labelPosition: 'top',
                    placeholder: _('Descripción'),
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Left main section configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // Right main section configuration
        const rigth_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [second_main_info],
        };

        // Upper section configuration with columns
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 5 }, rigth_main],
        };

        // Narrow upper section configuration
        const upper_section_narrow = {
            padding: 10,
            rows: [main_info, second_main_info],
        };

        // Window configuration for detailed view
        const detailsCasino = webix.ui({
            view: 'window',
            move: true,
            id: 'detailsCasino',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close window action
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'dtDetails2',
                type: 'clean',
                rows: [upper_section_narrow],
            },
        });

        // Main form configuration
        return {
            view: 'form',
            id: 'formDetails',
            rows: [
                screen !== 'small' ? upper_section : { height: 1, width: 0 }, // Conditional rendering based on screen size
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(this.app, 'withdrawTransDetail:select', (person) => {
            console.log('Entro'); // Log entry for debugging
            if (screen.width > 500 && screen.height > 500) {
                form.setValues(person); // Set form values for larger screens
                this.$$('Monto').setValue(
                    webix.i18n.priceFormat(person.Amount), // Format and set amount value
                );
            } else {
                $$('dtDetails2').setValues(person); // Set values for smaller screens
            }
        });
    }
}

// FILE DOCUMENTED
